import { render, staticRenderFns } from "./TextareaInputConfig.vue?vue&type=template&id=fead2a70&scoped=true"
import script from "./TextareaInputConfig.vue?vue&type=script&lang=js"
export * from "./TextareaInputConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fead2a70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fead2a70')) {
      api.createRecord('fead2a70', component.options)
    } else {
      api.reload('fead2a70', component.options)
    }
    module.hot.accept("./TextareaInputConfig.vue?vue&type=template&id=fead2a70&scoped=true", function () {
      api.rerender('fead2a70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/config/TextareaInputConfig.vue"
export default component.exports